import { param } from "framer-motion/client";
import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";
import { payCycle } from "../../../assets/data/enumData";

export const fetchAllTemplates = async (params) => {
  try {
    const response = await axiosRequest({
      method: "GET",
      url: `${ENDPOINTS.EMAILTEMPLATE.GET_ALL}`,
      params: {
        coll: params.coll,
        lim: params.lim,
        pg: params.pg,
        ret: params.ret || null,
        ref: params.ref || null,
        extret: params.extret || null,
        sort: JSON.stringify(params.sort),
        fil: JSON.stringify(params.fil),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching templates:", error);
    throw error;
  }
};

export const addTemplate = async (params) => {
  try {
    const response = await axiosRequest({
      method: "POST",
      url: `${ENDPOINTS.EMAILTEMPLATE.ADD}`,
      data: {
        coll: params.coll,
        payload: params.payload,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding template:", error);
    throw error;
  }
};

export const deleteTemplate = async (params) => {
  try {
    const response = await axiosRequest({
      method: "DELETE",
      url: `${ENDPOINTS.EMAILTEMPLATE.DELETE}`,
      data: {
        coll: params.coll,
        uiid: params.uiid,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting template:", error);
    throw error;
  }
};

export const fetchTemplateById = async (params) => {
  try {
    const response = await axiosRequest({
      method: "GET",
      url: `${ENDPOINTS.EMAILTEMPLATE.GET}`,
      params: {
        coll: params.coll,
        fil: JSON.stringify(params.fil),
        ret: params.ret || null,
        sort: params.sort || null,
        extret: params.extret || null
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching template by ID:", error);
    throw error;
  }
};

export const updateTemplate = async (params) => {
  try {
    const response = await axiosRequest({
      method: "PATCH",
      url: `${ENDPOINTS.EMAILTEMPLATE.UPDATE}?coll=${params.coll}&uiid=${params.uiid}`,
      data: {
        payload: params.payload,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating template:", error);
    throw error;
  }
};
export const fetchAssignedData = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.JOBS.GET_ALL,
    params: {
      ...params,
    },
  });
};

// export const fetchshuffleData=async( data )=>{
//    return await axiosRequest({
//     method:"POST",
//     url:ENDPOINTS.SHUFFLE.ADD,
//     data

//    })

// }

export const fetchshuffleData = async ({ coll = "Shuffle", payload }) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.SHUFFLE.ADD,
    data: {
      coll,
      payload,
    },
  });
};

export const fetchfollowupshuffleData = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.SHUFFLE.GET_ALL,
    params: {
      ...params,
    },
  });
};
export const fetchInstantlyCampaign = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INSTANTLY.GETALL_CAMPAIGN,
    params: {
      ...params,
    },
  });
};
export const getInstantlyCampaign=async(params)=>{
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INSTANTLY.GET_CAMPAIGN,
    params: {
      ...params,
    },
  });
}
// export const f
export const fetchInstantlyBulkAnalyst = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INSTANTLY.GET_BULK_ANALYST,
    params: {
      ...params,
    },
  });
};
export const createInstantlyCampaignApi = async ({ accessId, payload }) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.INSTANTLY.ADD_CAMPAIGN,
    data: {
      payload,
      accessId,
    },
  });
};
export const pauseInstantlyCampaignApi = async ({ accessId, payload }) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.INSTANTLY.PAUSE_CAMPAIGN,
    data: {
      payload,
      accessId,
    },
  });
};
export const startInstantlyCampaignApi = async ({ accessId, payload }) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.INSTANTLY.START_CAMPAIGN,
    data: {
      payload,
      accessId,
    },
  });
};
export const createDuplicateCampaignApi=async({accessId, payload})=>{
  return await axiosRequest({
    method:"POST",
    url:ENDPOINTS.INSTANTLY.DUPLICATE_CAMPAIGN,
    data:{
      payload,
      accessId,
    }
  })
}
export const deleteInstantlyCampaignApi = async ({ accessId, payload }) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.INSTANTLY.DELETE_CAMPAIGN,
    data: {
      payload,
      accessId,
    },
  });
};
export const updateInstantlyCampaignApi = async ({ accessId, payload }) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.INSTANTLY.UPDATE_CAMPAIGN,
    data: {
      payload,
      accessId,
    },
  });
};

export const sendBulkEmailsStartApi = async ({ payload, coll = "ProspectEmailLog" }) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.PROSPECTEMAILLOGS.ADD,
    data: {
      payload,
      coll,
    },
  })
}

export const fetchEmailCounts = async (params) => {
  return await axiosRequest({
        method: "GET",
        url: ENDPOINTS.EMAIL.GET,
        params: {
            coll: params.coll,
            fil: JSON.stringify(params.fil),
        },
    });
};
export const fetchInstantlyAccessId = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INTEGRATIONS.GET,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.fil),
      ret: "uiid status"
    },
  });
};